import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
import store from "./store";
import axios from "axios";
import Qs from "qs";
import request from "./utils/request.js";
import globalFun from "./utils/globalFunction.js";
import animated from "animate.css";
import babelpolyfill from "babel-polyfill";
import "babel-polyfill";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, { ak: "p3ZCTWpPVC6jkD7TGMFgHgNFtK1HRTyM" });
Vue.prototype.$http = axios;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 360000;
Vue.prototype.$Qs = Qs;
Vue.prototype.$request = request;
Vue.prototype.$globalFun = globalFun;
Vue.config.productionTip = false;
Vue.use(animated);
Vue.use(ElementUI);
Vue.use(babelpolyfill);
// 关闭console.log
// console.log = function() {}
new Vue({
    el: "#app",
    components: { App },
    template: "<App/>",
    router,
    store
});



// WEBPACK FOOTER //
// ./src/main.js